module.exports = __webpack_public_path__ + "assets/audio/2323526a4a287ab969a75ba6481a4760.wav";